var display = 0;
//            ^
//            |
//            |



// 1 = normal function
// 2 = countdown off - no delivery message until after 17:00
// 3 = countdown off - 2 day delivery message (e.g.  if Monday, Wednesday delivery advised)
// 0 = custom message - below 
// custommessage = "It's a bank holiday weekend—our warehouse will be closed until Tuesday!";
    // custommessage = "<div class='announcement-bar__message'>";
    //custommessage = "";    
    //custommessage += "FREE DELIVERY WHEN YOU SPEND £69 OR MORE*  ";
    //custommessage += "<span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland</span>";
   
    custommessage = "<span style='font-size:12px; color:#333;'>Drydrinker</span>";
  //   custommessage +="</div>";


var ddate = new Date();
var iyear = ddate.getFullYear();
var imonth = ddate.getMonth(); imonth++;
var iday = ddate.getDate();

var iweek =ddate.getDay();
var ihours = ddate.getHours();
var iminutes = ddate.getMinutes();

if (display==2 && ihours<17 ){
    wholemessage = "<div class='announcement-bar__message'>";
    wholemessage += "FREE DELIVERY WHEN YOU SPEND £99 OR MORE*  ";
    wholemessage += "<span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland - Weekdays Only</span></div>";

lastmessage = "<div id='menu-right-top'><a href='https://drydrinker.com/pages/delivery'>DELIVERY</a>";
  lastmessage += "<span class='shrink-it'>  &nbsp; <a href='https://drydrinker.com/pages/contacting-dry-drinker'>CONTACT US</a>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/invest'>INVEST IN US</a></span>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/blogs/blog'>BLOG</a>";
  /* lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/corporate-gifting'>CORPORATE</a>"; */
  /* lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/trade-account'>TRADE</a>"; */
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/partnerships'>INFLUENCERS</a>";
  lastmessage += "  </div>";
  
  wholemessage += " "+lastmessage+"</div>";
  document.getElementById("countdown-clock").innerHTML = wholemessage; 
   throw new Error();
}

if (display==3)
{
  wholemessage = "<div class='announcement-bar__message'>PLACE YOUR ORDER BY <span style='color:#FFFF00;'>5PM</span> ";
  if(iweek==1){wholemessage += "MONDAY FOR WEDNESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==2){wholemessage += "TUESDAY FOR THURSDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==3){wholemessage += "WEDNESDAY FOR FRIDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==4){wholemessage += "THURSDAY - Select Saturday delivery - Get your drinks this weekend*  <span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland</span>"; endmessage = "";  lastmessage = "";}
                      
  if(iweek==5){wholemessage = "<div class='announcement-bar__message'>FREE DELIVERY WHEN YOU SPEND £99 OR MORE*<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}                      
  if(iweek==6){wholemessage = "<div class='announcement-bar__message'>FREE DELIVERY WHEN YOU SPEND £99 OR MORE*<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}  
  if(iweek==0){wholemessage = "<div class='announcement-bar__message'>ORDER NOW FOR TUESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}  
  lastmessage = "<div id='menu-right-top'><a href='https://drydrinker.com/pages/delivery'>DELIVERY</a>";
  lastmessage += "<span class='shrink-it'>  &nbsp; <a href='https://drydrinker.com/pages/contacting-dry-drinker'>CONTACT US</a>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/invest'>INVEST IN US</a></span>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/blogs/blog'>BLOG</a>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/corporate-gifting'>CORPORATE</a>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/trade-account'>TRADE</a>";
  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/partnerships'>INFLUENCERS</a>";
  lastmessage += "  </div>";
  
  wholemessage += " "+lastmessage+"</div>";
  document.getElementById("countdown-clock").innerHTML = wholemessage; 
  throw new Error();
}


if (display==0){
    

   wholemessage = "<div id='menu-announce' class='announcement-bar__message'>As it's the long holiday weekend - please be mindful of delivery times</div>";
 //   wholemessage += custommessage;

 
 //  wholemessage += "<div id='menu-left-top'></div>";

  // wholemessage += "<span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland - Weekdays Only</span></div>";
 //   wholemessage += "</div>";
  //lastmessage = "<div id='menu-right-top'><a href='https://drydrinker.com/pages/delivery'>DELIVERY</a>";
  //lastmessage += "<span class='shrink-it'>  &nbsp; <a href='https://drydrinker.com/pages/contacting-dry-drinker'>CONTACT US</a>";
 /* lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/corporate-gifting'>CORPORATE</a></span>"; */
  //lastmessage += "  &nbsp; <a href='https://drydrinker.com/blogs/blog'>BLOG</a>";
  //lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/invest'>INVEST IN US</a>";
  /* lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/trade-account'>TRADE</a>"; */
  //lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/partnerships'>INFLUENCERS</a>";
 // lastmessage += "  </div>";

 // lastmessage = "";
//  wholemessage += " "+lastmessage+"</div>";
 wholemessage +="";
  document.getElementById("countdown-clock").innerHTML = wholemessage; 



  
   throw new Error();
}

// lastmessage = "&bull; FREE DELIVERY WHEN YOU SPEND £69 OR MORE*  <span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland - Weekdays Only</span>";
   lastmessage = "";

if(ihours>=17){
  wholemessage = "<div class='announcement-bar__message'>PLACE YOUR ORDER BY <span style='color:#FFFF00;'>5PM</span> ";
  if(iweek==1){wholemessage += "TUESDAY FOR WEDNESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==2){wholemessage += "WEDNESDAY FOR THURSDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==3){wholemessage += "THURSDAY FOR FRIDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}
  if(iweek==4){wholemessage += "FRIDAY - Select Saturday delivery - Get your drinks this weekend* <span style='font-size:8px; position:relative; top:-2px;'>*UK Mainland</span>"; endmessage = "";  lastmessage = "";}
                      
  if(iweek==5){wholemessage = "<div class='announcement-bar__message'>FREE DELIVERY WHEN YOU SPEND £99 OR MORE<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}                      
  if(iweek==6){wholemessage = "<div class='announcement-bar__message'>FREE DELIVERY WHEN YOU SPEND £99 OR MORE<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}  
  if(iweek==0){wholemessage = "<div class='announcement-bar__message'>PLACE YOUR ORDER BY 5 PM MONDAY FOR TUESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span></span>"; endmessage = "";}  
  
  wholemessage += " "+endmessage;

//  lastmessage = "<div id='menu-right-top'><a href='https://drydrinker.com/pages/delivery'>DELIVERY</a>";
//  lastmessage += "<span class='shrink-it'>  &nbsp; <a href='https://drydrinker.com/pages/contacting-dry-drinker'>CONTACT US</a>";
/*  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/corporate-gifting'>CORPORATE</a></span>"; */
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/blogs/blog'>BLOG</a>";
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/invest'>INVEST IN US</a>";
  /* lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/trade-account'>TRADE</a>"; */
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/partnerships'>INFLUENCERS</a>";
//  lastmessage += "  </div>";
  
  wholemessage += " "+lastmessage+"</div>";
  document.getElementById("countdown-clock").innerHTML = wholemessage;
  throw new Error();
}

if(ihours<17){
  CountDownTimer(imonth + "/" + iday + "/" + iyear + " 5:00 PM", "countdown-clock");
  
  function CountDownTimer(dt, id) {
      var end = new Date(dt);
      var _second = 1000;
      var _minute = _second * 60;
      var _hour = _minute * 60;
      var _day = _hour * 24;
      var timer;
      var endmessage = " FOR DELIVERY TOMORROW<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span>";

      function showRemaining() {
       
          var now = new Date();
          var distance = end - now;

          if (distance < 0) {
              clearInterval(timer);
              var hours   = 23 - (Math.floor((-distance % _day) / _hour));
              var minutes = 59 - (Math.floor((-distance % _hour) / _minute));
              var seconds = 59 - (Math.floor((-distance % _minute) / _second));
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              return;
          }
        
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % _day) / _hour);
          var minutes = Math.floor((distance % _hour) / _minute);
          var seconds = Math.floor((distance % _minute) / _second);
        
          var wholemessage = "Order in the next";
          if(iweek==5){
            var wholemessage = "Order in ";
          }
          if (hours != 0) {
            if (hours >= 10) {
              wholemessage += " " + hours + " hours";
            }

            if (hours < 10 && hours > 1){
              wholemessage += " " + hours + " hours";
            }
            
            if (hours == 1){
              wholemessage += " 1 hour";
            }
          }
        
          if (minutes >= 10) {
            wholemessage += " " + minutes + " minutes";
          }
        
          if (minutes < 10 && minutes > 1) {
            wholemessage += " " + minutes + " minutes";
          }
        
          if (minutes == 1) {
            wholemessage += " " + minutes + " minute";
          }
        
          if (minutes == 0) {
            wholemessage += " " + minutes + " minutes";
          }                
        
         if(iweek==5){
              endmessage = " - Select Saturday delivery - Get your drinks this weekend<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span>";
              
          }

        if(iweek==6){wholemessage = "ORDER NOW FOR TUESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span>"; endmessage = "";}
        if(iweek==0){wholemessage = "PLACE YOUR ORDER BY 5 PM MONDAY FOR TUESDAY DELIVERY<span style='font-size:8px; position:relative; top:-5px;'>*</span> <span style='font-size:8px; position:relative; top:-3px;'>*UK MAINLAND</span>"; endmessage = "";}


//          lastmessage = "<div id='menu-right-top'><a href='https://drydrinker.com/pages/delivery'>DELIVERY</a>";
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/contacting-dry-drinker'>CONTACT US</a>";
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/about-dry-drinker-1'>ABOUT US</a>";
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/blogs/blog'>BLOG</a>";
/*  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/corporate-gifting'>CORPORATE</a>"; */
/*  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/trade-account'>TRADE</a>"; */
        if(iweek!=5){
//  lastmessage += "  &nbsp; <a href='https://drydrinker.com/pages/partnerships'>INFLUENCERS</a>";
        }
//  lastmessage += "  </div>";
        
        finalmessage = "<div class='announcement-bar__message'>"+wholemessage+" "+endmessage+" "+lastmessage+"</div>";                   
                              
        document.getElementById(id).innerHTML = finalmessage;
        timer = setInterval(showRemaining, 60*1000);
      }
    showRemaining();      
  }
}